export enum ResourceTypeHeadingNameEnum {
  File = 'File',
  ScormPackage = 'Scorm Package',
  WebLink = 'Web Link',
}
